module.exports = __webpack_public_path__ + "img/thoughts.072314e7.svg";